export default __webpack_public_path__ + "static/media/living-room3.739ef06b.jpg";